import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <p>
        &copy; 2020 Airbnb clone! Crated by Suhail, No right reserved - this is
        a demo!
      </p>
      <p>Privacy . &bull; Terms &bull; Sitemap &bull; Company Details</p>
    </div>
  );
}

export default Footer;
